export enum ImageSize {
  Square20 = '20x20',
  Square20Inscribed = '20x20i',
  Square50 = '50x50',
  Rect80x60Inscribed = '80x60i',
  Square80 = '80x80',
  Rect133x100InscribedWithEnlarge = '133x100iwe',
  Rect160x120InscribedWithEnlarge = '160x120iwe',
  Rect200x150InscribedWithEnlarge = '200x150iwe',
  Square200InscribedWithEnlarge = '200x200iwe',
  Square300InscribedWithEnlarge = '300x300iwe',
  Rect400x600InscribedWithEnlarge = '400x600iwe',
  Square400InscribedWithEnlarge = '400x400iwe',
  JsonLd = 'json-ld',
  FacebookShare = 'facebook-share',
}
